import { useCallback, useContext } from 'react'

import { Box, Chip, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import CharacterLimitInput from '../../../CharacterLimitInput'
import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const useStyles = makeStyles((theme) => ({
  selectedChip: {
    backgroundColor: '#D9EEF8',
    '&.MuiChip-clickable.MuiChip-outlinedPrimary:focus': {
      backgroundColor: '#D9EEF8',
    },
  },
  chipLabel: {
    color: theme.palette.common.black,
  },
}))

const Admissions = () => {
  const classes = useStyles()
  const { item, onUpdateField, validation } = useContext(ContentModalContext)

  const onSelect = useCallback(
    (chip) => {
      const value = chip.target.innerText
      let newEligibilityArr = [...(item[FIELD_NAMES.ELIGIBILITY] ?? [])]
      if (!newEligibilityArr.includes(value)) {
        newEligibilityArr.push(value)
      } else {
        newEligibilityArr = newEligibilityArr.filter((chip: string) => chip !== value)
      }
      onUpdateField(FIELD_NAMES.ELIGIBILITY, newEligibilityArr)
    },
    [item, onUpdateField],
  )

  const grades = ['6th', '7th', '8th', '9th', '10th', '11th', '12th', 'High School Graduate']

  return (
    <Section title="Admissions">
      <CharacterLimitInput
        id={FIELD_NAMES.ADMISSIONS_DESCRIPTION}
        value={item[FIELD_NAMES.ADMISSIONS_DESCRIPTION]}
        field={FIELD_NAMES.ADMISSIONS_DESCRIPTION}
        label={LABELS.ADMISSIONS_DESCRIPTION}
        placeholder={LABELS.ADMISSIONS_DESCRIPTION}
        onUpdateField={onUpdateField}
        validation={validation}
      />
      <Box>
        <Typography variant="subtitle2">{LABELS.ELIGIBILITY}</Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Select all eligible current or rising grades a the start of the program.
        </Typography>
      </Box>
      <Box
        display="flex"
        gridGap={8}
        flexWrap="wrap"
      >
        {grades.map((option) => {
          const isSelected = item[FIELD_NAMES.ELIGIBILITY]?.includes(option)
          return (
            <Chip
              key={option}
              classes={{ root: isSelected ? classes.selectedChip : undefined, label: classes.chipLabel }}
              variant="outlined"
              color="primary"
              label={option}
              onClick={onSelect}
            />
          )
        })}
      </Box>
    </Section>
  )
}

export default Admissions
